export function range(start: number, end: number, step = 1): number[] {
  if (start > end || step < 1) {
    return [];
  }
  return [...Array(end - start + 1).keys()]
    .filter((i) => !(i % step))
    .map((v) => start + v);
}

/**
 * Join array with commas and an "&" before the last item.
 */
export function joinWithCommasAnd(items: string[], lastSeparator = '&') {
  if (items.length === 0) {return '';}
  if (items.length === 1) {return items[0];}
  if (items.length === 2) {return `${items[0]} ${lastSeparator} ${items[1]}`;}
  return `${items.slice(0, -1).join(', ')} ${lastSeparator} ${items[items.length - 1]}`;
}
